import { useSelector } from "react-redux";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  InfoBanner,
  InfoBannerSeverity,
} from "@tenant/ui";
import clsx from "clsx";
import styles from "./PointsEligibilityBanner.module.scss";
import { AccountSelectors } from "@/modules/account";
import { TenantIconNameEnum } from "@/types/tenantIcons";
import { useIsExchangeFlow } from "@/utilities/flights/useIsExchangeFlow";

export const PointsEligibilityBanner = ({
  className,
}: {
  className?: string;
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PointsEligibilityBanner");
  const isExchangeFlow = useIsExchangeFlow();

  const hasMinimumRedemptionPoints = useSelector(
    AccountSelectors.getHasMinimumRedemptionPoints
  );

  const minimumRedemptionPoints = useSelector(
    AccountSelectors.getMinimumRedemptionPoints
  );

  // Hide banner during exchange flows
  if (
    hasMinimumRedemptionPoints ||
    !minimumRedemptionPoints ||
    isExchangeFlow
  ) {
    return null;
  }

  return (
    <InfoBanner
      severity={InfoBannerSeverity.INFO}
      icon={TenantIconNameEnum.pointsCreditCard}
      className={clsx(block, className)}
    >
      <div className={cn("content-container")}>
        <Accordion type="single" collapsible className={cn("accordion")}>
          <AccordionItem
            value="points-eligibility-details"
            className={cn("accordion-item")}
          >
            <AccordionTrigger className={cn("accordion-trigger")}>
              <span className={cn("title")}>
                {t("core-flights.fixedPricing.pointsEligibilityBanner.title", {
                  minimum: minimumRedemptionPoints.toLocaleString(),
                })}
              </span>
            </AccordionTrigger>
            <AccordionContent className={cn("accordion-content")}>
              <p className={cn("description")}>
                {t(
                  "core-flights.fixedPricing.pointsEligibilityBanner.description"
                )}
              </p>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </InfoBanner>
  );
};
